import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { GetPatientProfilePatientNameDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { notificationConfirmModalState } from '~/state/partials/patient_profile_drawer/atoms';

export const useFetchPatientName = () => {
  const { patientId } = useAtomValue(notificationConfirmModalState);
  const [getPatientName, { data, loading }] = useLazyQuery(GetPatientProfilePatientNameDocument);

  const patient = getNode(data, 'Patient');
  const patientName = patient ? `${patient.familyName}${patient.givenName}` : '';

  useEffect(() => {
    if (patientId) {
      getPatientName({ variables: { patientId } });
    }
  }, [getPatientName, patientId]);

  return { loading, patientName };
};
